import React from "react";
import { Form } from "components";

const processesStatuses = [
  { label: "Pendente", value: "PENDING" },
  { label: "Processando", value: "PROCESSING" },
  { label: "Processado", value: "PROCESSED" },
  { label: "Falhou", value: "FAILED" },
  { label: "Cancelando", value: "CANCELLING" },
  { label: "Cancelado", value: "CANCELED" },
];

export function Filters({ filters, onChange, onClean }) {
  return (
    <Form>
      <div className="row">
        <Form.Field className="col-md-4">
          <Form.Label>Situação</Form.Label>
          <Form.Select
            placeholder="Todas situações"
            options={processesStatuses}
            value={filters.status_name}
            onChange={(value) => onChange("status_name", value)}
          />
        </Form.Field>
        <Form.Field className="col-md-2">
          <Form.Button className="button-clean-filter" onClick={onClean}>
            Resetar filtros
          </Form.Button>
        </Form.Field>
      </div>
    </Form>
  );
}
